// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"APIPurchaseAdjustmentPage_headerActions__1Bium","inputContainer":"APIPurchaseAdjustmentPage_inputContainer__2SBod"};